<template>
  <div>
    <div class="alert alert-success mt-3">
      <div class="row">
        <div class="col-1 d-flex border-right">
          <icon :icon="['fad', 'info']" class="text-info fa-3x mx-auto my-auto"/>
        </div>
        <div class="col">
          <h5>Payment in progress</h5>
          You will receive an invoice once the payment has beend processed. This can take up to two hours.<br>
          Only then can your abstract be submitted.<br>
          <br>
          For questions regarding the payment please refer to <a href="mailto:abstracts@ebmt.org">abstracts@ebmt.org</a>.
        </div>
      </div>
      <div class="row mt-3">
        <div class="col offset-1">
          <payment_status :abstract_id="this.$route.params.id"></payment_status>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col d-flex">
        <router-link
            :to="'../' + nextSite(getCurrentPages(abstract.setting_submission_id), getCurrentPageByType(abstract.setting_submission_id, 4).id)"
            class="ml-auto"
            v-if="hasNextSite(getCurrentPages(abstract.setting_submission_id), getCurrentPageByType(abstract.setting_submission_id, 4).id)">
          <button type="button" class="btn btn-info float-right">{{ wording[0].buttons.next }}
            <icon :icon="['fas', 'angle-right']" size="lg"/>
          </button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import payment_status from "@/components/payment/payment_status";
import {mapActions, mapGetters, mapState} from "vuex";

export default {
  name: 'stripe_success',
  components: {payment_status},
  computed: {
    ...mapState([
      'user', 'wording', 'settings', 'processing', 'abstract'
    ]),
    ...mapGetters([
      'getCurrentPages', 'getCurrentPageById', 'getCurrentPageByType'
    ]),
  },
  created() {
    this.setProcess();
  },
  methods: {
    ...mapActions('payment', [
      'PAYMENT_PROCESS'
    ]),
    setProcess() {
      this.PAYMENT_PROCESS(this.$route.params.id).then((response) => {
        this.abstract.payment_process = true;
        this.$noty.success(this.wording[0].notify.save_success);
      }).catch((error) => {
        this.$noty.error(this.wording[0].notify.save_not_success);
      })
    }
  }
}

</script>

<style scoped>

</style>
